import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { Stack, CommandButton, TextField } from '@bingads-webui-react/fabric-control';

import {
  vendorNameKey,
  campaignThirdPartyVendorNames,
  campaignThirdPartyVendors,
} from '../../model/campaign-third-party-vendor-setting';
import { thridPartyMeasurementTrackingStyles } from '../../styles/third-party-measurement-setting-styles';
import { WarningMessage } from './warning-message';
import { customVendorConfigs } from './custom-config';

export const ThirdPartyTrackingSetting = (props) => {
  const {
    i18n,
    setting,
    setSetting,
    removeSetting,
    overrideStyles,
    doubleVerifyLinkEstablished,
  } = props;

  const styles = useMemo(() => ({
    ...thridPartyMeasurementTrackingStyles,
    ...overrideStyles,
  }), [overrideStyles]);

  const VendorConfig = customVendorConfigs[setting[vendorNameKey]];
  const isiSPOTSetting = setting[vendorNameKey] === campaignThirdPartyVendors.ISPOT;

  return (
    <div>
      <Stack
        verticalAlign="center"
        horizontal
        className="default-thirdparty-setting"
        styles={styles.thirdPartyMeasurementVendorSettings}
      >
        <Stack
          verticalAlign="center"
          horizontal
          className="vendor-settings"
        >
          <TextField
            className="third-party-measurement-vendor"
            readOnly
            defaultValue={i18n.getString(campaignThirdPartyVendorNames[setting[vendorNameKey]])}
          />
          {VendorConfig &&
            <VendorConfig
              setting={setting}
              i18n={i18n}
              setSetting={setSetting}
              doubleVerifyLinkEstablished={doubleVerifyLinkEstablished} // TODO: add api call to implement link status for DV
            />}
        </Stack>
        <CommandButton
          className="third-party-measurement-remove-button"
          onClick={removeSetting} // TODO: add vendor
          iconProps={{ iconName: 'Delete' }}
          styles={styles.thirdPartyMeasurementRemoveButton}
          ariaLabel={i18n.getString(_TL_('Remove Vendor'))}
        />
      </Stack>
      {isiSPOTSetting &&
        <Stack styles={styles.warningMessageContainer}>
          <WarningMessage
            i18n={i18n}
            message={i18n.getString(_TL_('This vendor only applies to U.S'))}
          />
        </Stack>
      }
    </div>
  );
};

ThirdPartyTrackingSetting.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  setting: PropTypes.shape({
    [vendorNameKey]: PropTypes.string,
  }).isRequired,
  setSetting: PropTypes.func.isRequired,
  removeSetting: PropTypes.func.isRequired,
  overrideStyles: PropTypes.shape({}),
  doubleVerifyLinkEstablished: PropTypes.bool,
};

ThirdPartyTrackingSetting.defaultProps = {
  overrideStyles: {},
  doubleVerifyLinkEstablished: false,
};

